import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { IProjectTemplate } from '@d-id/types';
import styled from '@emotion/styled';
import { reaction } from 'mobx';
import { useCallback, useEffect, useState } from 'react';
import { TemplateDetails } from './TemplateDetails';
import { TemplatesList } from './TemplateList';

const TemplatesPanelContainer = styled.div`
    padding: 8px 20px 0 !important;
    height: calc(100% - 8px);
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const TemplatesPanel = () => {
    const { store, selectedTemplate, setSelectedTemplate, selectedTemplateIndex, setSelectedTemplateIndex } = useAdvancedEditorContext();
    const [filter, setFilter] = useState('all');
    const [search, setSearch] = useState('');

    useEffect(() => {
        const dispose = reaction(
            () => store.custom?.cropSettings,
            (_, prev) => {
                if (!prev) return;
                setSelectedTemplate(null);
            }
        );

        return () => {
            dispose();
        };
    }, [store]);

    const handleBack = useCallback(() => {
        setSelectedTemplate(null);
        setSelectedTemplateIndex(null);
    }, []);

    const handleSetSelectedTemplate = useCallback((template: IProjectTemplate | null, index: number | null) => {
        setSelectedTemplate(template);
        setSelectedTemplateIndex(index);
    }, []);

    return (
        <TemplatesPanelContainer data-testid="templates-panel">
            {selectedTemplate && selectedTemplateIndex !== null ? (
                <TemplateDetails
                    selectedTemplate={selectedTemplate}
                    selectedTemplateIndex={selectedTemplateIndex}
                    onBack={handleBack}
                    search={search}
                    filter={filter}
                />
            ) : (
                <TemplatesList
                    setSelectedTemplate={handleSetSelectedTemplate}
                    search={search}
                    setSearch={setSearch}
                    filter={filter}
                    setFilter={setFilter}
                />
            )}
        </TemplatesPanelContainer>
    );
};
